
export const codeValidator = function(value, callback) {
    if (/^([a-zA-Z0-9_-]){1,10}$/.test(value)) {
        callback(true);
      } else {
        callback(false);
      }
}

export const nameValidator = function(value, callback) {
  if(value.length > 0 && value.length <= 100){
    if (/^([a-zA-Z0-9_/-]+( [a-zA-Z0-9_/-]+)*)$/.test(value)) {
      callback(true);
    } else {
      callback(false);
    }
  }else{
    callback(false)
  }
   
}

export const typeValidator = function (value, callback) {
   
    if (value.length !== 0 && value != '' && value != null) {
    callback(true)
  }else{
    callback(false)
  }
}
export const nameEmptyValidator = function (value, callback) {
 
    callback(false)
}

export const maxLengthValidator =function (value, callback) {
    if (value !=null && value.length > 50) {        
        this.instance.setDataAtCell(this.row, this.col, value.substring(0, 50), null);
    }
    callback(true);
}